// @ts-ignore
/* eslint-disable */
import { request } from "@umijs/max";
import {
  getCurrentUser as authGetCurrentUser,
  login as authLogin,
  logout as authLogout,
  LoginParams,
  storeAuthData,
} from "../auth";

/** Lấy thông tin người dùng hiện tại GET /v1/auth/me */
export async function currentUser(options?: { [key: string]: any }) {
  try {
    const user = await authGetCurrentUser();
    return {
      data: {
        name: user.fullName,
        avatar: undefined, // Admin không có avatar field
        userid: user.id,
        email: user.email,
        signature: user.role,
        title: user.role,
        group: user.role,
        tags: [],
        notifyCount: 0,
        unreadCount: 0,
        country: "VN",
        access: user.role,
        geographic: {
          province: { label: "Hanoi", key: "hanoi" },
          city: { label: "Hanoi", key: "hanoi" },
        },
        address: "",
        phone: undefined, // Admin không có phone field
      } as API.CurrentUser,
    };
  } catch (error) {
    console.error("Failed to get current user:", error);
    throw error;
  }
}

/** API đăng xuất */
export async function outLogin(options?: { [key: string]: any }) {
  try {
    authLogout();
    return { success: true };
  } catch (error) {
    console.error("Logout error:", error);
    throw error;
  }
}

/** API đăng nhập POST /admin-users/login */
export async function login(
  body: LoginParams,
  options?: { [key: string]: any }
) {
  try {
    const result = await authLogin(body);
    // Store authentication data
    storeAuthData(result);

    return {
      status: "ok",
      type: "account",
      currentAuthority: result.user.role,
    } as API.LoginResult;
  } catch (error) {
    console.error("Login error:", error);
    throw error;
  }
}

/** Backend không cung cấp comment cho endpoint này GET /api/notices */
export async function getNotices(options?: { [key: string]: any }) {
  return request<API.NoticeIconList>("/api/notices", {
    method: "GET",
    ...(options || {}),
  });
}

/** Lấy danh sách quy tắc GET /api/rule */
export async function rule(
  params: {
    // query
    /** Trang hiện tại */
    current?: number;
    /** Dung lượng trang */
    pageSize?: number;
  },
  options?: { [key: string]: any }
) {
  return request<API.RuleList>("/api/rule", {
    method: "GET",
    params: {
      ...params,
    },
    ...(options || {}),
  });
}

/** Cập nhật quy tắc PUT /api/rule */
export async function updateRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "update",
      ...(options || {}),
    },
  });
}

/** Tạo quy tắc mới POST /api/rule */
export async function addRule(options?: { [key: string]: any }) {
  return request<API.RuleListItem>("/api/rule", {
    method: "POST",
    data: {
      method: "post",
      ...(options || {}),
    },
  });
}

/** Xóa quy tắc DELETE /api/rule */
export async function removeRule(options?: { [key: string]: any }) {
  return request<Record<string, any>>("/api/rule", {
    method: "POST",
    data: {
      method: "delete",
      ...(options || {}),
    },
  });
}
